var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import PROPS from './Props';
import { IDENTIFIERS, GENERAL_IDENTIFIERS } from './Identifiers';
import { validateJson } from './Validators';
import { setters } from './setters';
import { buildLink, buildOgMeta, buildStandardMeta, buildStructureData, buildTitle, } from './builders';
export var TAG_SCHEMAS = (_a = {},
    _a[IDENTIFIERS.TITLE] = __assign(__assign({}, buildTitle(true)), { getValue: function (tag) { return tag && tag.children; }, setValue: function (tag, value) {
            if (tag && typeof tag === 'object') {
                tag.children = value;
                return { isValid: true };
            }
            return { isValid: false };
        } }),
    _a[IDENTIFIERS.DESCRIPTION] = buildStandardMetaSchema('description'),
    _a[IDENTIFIERS.OG_TITLE] = buildOgMetaSchema('og:title'),
    _a[IDENTIFIERS.OG_DESCRIPTION] = buildOgMetaSchema('og:description'),
    _a[IDENTIFIERS.OG_IMAGE] = buildOgMetaSchema('og:image'),
    _a[IDENTIFIERS.OG_IMAGE_WIDTH] = buildOgMetaSchema('og:image:width'),
    _a[IDENTIFIERS.OG_IMAGE_HEIGHT] = buildOgMetaSchema('og:image:height'),
    _a[IDENTIFIERS.FB_ADMINS] = buildOgMetaSchema('fb:admins'),
    _a[IDENTIFIERS.ROBOTS] = buildStandardMetaSchema('robots'),
    _a[IDENTIFIERS.STRUCTURED_DATA] = __assign(__assign({}, buildStructureData(true)), { getValue: function (tag) { return tag.children; }, setValue: function (tag, value, enableValidation) {
            var validator = { isValid: true };
            if (enableValidation) {
                validator = validateJson(value);
            }
            if (validator.isValid) {
                tag.children = value;
            }
            return validator;
        } }),
    _a[IDENTIFIERS.CANONICAL] = buildLinkSchema('canonical'),
    _a[GENERAL_IDENTIFIERS.LINK] = function (rel) { return buildLinkSchema(rel); },
    _a[GENERAL_IDENTIFIERS.STANDARD_META] = function (name) { return buildStandardMetaSchema(name); },
    _a[GENERAL_IDENTIFIERS.OG_TAG] = function (name) { return buildOgMetaSchema(name); },
    _a);
function buildOgMetaSchema(property) {
    return __assign(__assign({}, buildOgMeta(property, '')), { getValue: function (tag) { return tag.props[PROPS.CONTENT]; }, setValue: function (tag, value) {
            return setters[GENERAL_IDENTIFIERS.STANDARD_META](tag, value);
        } });
}
function buildStandardMetaSchema(name) {
    return __assign(__assign({}, buildStandardMeta(name, '')), { getValue: function (tag) { return tag.props[PROPS.CONTENT]; }, setValue: function (tag, value) {
            return setters[GENERAL_IDENTIFIERS.STANDARD_META](tag, value);
        } });
}
function buildLinkSchema(rel) {
    return __assign(__assign({}, buildLink(rel, '')), { getValue: function (tag) { return tag.props[PROPS.HREF]; }, setValue: function (tag, value, enableValidation) {
            return setters[GENERAL_IDENTIFIERS.LINK](tag, value, enableValidation);
        } });
}
